import React from "react";
import { RichText as PrismicRichText } from "prismic-dom";
import { Box, Flex, Image } from "rebass";

import { Article, H2, PrimaryButton } from "components";

let linkResolver = function (doc) {
  return "/" + doc.type;
};

export const SideBySide = (props) => {
  if (props.primary) {
    return (
      <Box bg="white">
        <Box
          w="100%"
          mx="auto"
          pt={[32, 48]}
          px={[4, 5, 6, 8]}
          style={{ maxWidth: "90em" }}
        >
          <Flex
            is="section"
            flexDirection={["column", null, "row"]}
            align="center"
            mt={[3, 4]}
            mb={[3, 4]}
          >
            {props.primary.variant === "Image on Left" && (
              <Box
                is="a"
                href={props.primary.image_link && props.primary.image_link.url}
                w={[1, null, 1 / 2]}
                mr={[0, 0, 7, 8]}
              >
                <Image
                  srcSet={
                    props.primary.image.quarter.url +
                    " 1000w, " +
                    props.primary.image.half.url +
                    " 2000w, " +
                    props.primary.image.url +
                    " 2500w"
                  }
                  style={{ width: "100%" }}
                  alt={props.alt}
                />
              </Box>
            )}
            {(!props.primary.alt_image || !props.primary.alt_image.url) && (
              <Flex
                flexDirection="column"
                justifyContent="center"
                w={[1, null, 1 / 2]}
                px={[0, 5, 6]}
                py={[4, 0, 0]}
              >
                {props.primary.title && props.primary.title[0] && (
                  <H2
                    children={props.primary.title[0].text}
                    mb={5}
                    color="violet"
                  />
                )}
                {props.primary.content &&
                  props.primary.content[0] &&
                  props.primary.content[0].text && (
                    <Box mb={32}>
                      <Article
                        dangerouslySetInnerHTML={{
                          __html: PrismicRichText.asHtml(
                            props.primary.content,
                            linkResolver
                          ),
                        }}
                      />
                    </Box>
                  )}
                {props.primary.button_text && props.primary.button_link && (
                  <Box>
                    <PrimaryButton
                      children={props.primary.button_text}
                      is="a"
                      href={props.primary.button_link}
                    />
                  </Box>
                )}
              </Flex>
            )}
            {(props.primary.variant === "Image on Right" ||
              (props.primary.alt_image && props.primary.alt_image.url)) && (
              <Box
                is="a"
                href={
                  props.primary.alt_image && props.primary.alt_image.url
                    ? props.primary.alt_image_link.url
                    : props.primary.image_link && props.primary.image_link.url
                }
                w={[1, null, 1 / 2]}
                ml={[0, 0, 7, 8]}
                mt={
                  props.primary.alt_image && props.primary.alt_image.url
                    ? [4, 0]
                    : 0
                }
              >
                <Image
                  srcSet={
                    props.primary.alt_image && props.primary.alt_image.url
                      ? props.primary.alt_image.quarter.url +
                        " 1000w, " +
                        props.primary.alt_image.half.url +
                        " 2000w, " +
                        props.primary.alt_image.url +
                        " 2500w"
                      : props.primary.image.quarter.url +
                        " 1000w, " +
                        props.primary.image.half.url +
                        " 2000w, " +
                        props.primary.image.url +
                        " 2500w"
                  }
                  style={{ width: "100%" }}
                  alt={props.alt}
                />
              </Box>
            )}
          </Flex>
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/slices/SideBySide/SideBySide.js